// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"7b8f4d61","232":"fa4475d1","279":"cb60ce1a","453":"52aa5bb0","543":"410fe1c9","777":"e7f76c26"}[chunkId] + ".chunk.js";
};